























import { Component, Vue } from 'vue-property-decorator';
import { BitFlyerModule } from '@/store/modules/bitflyer';
import OrderbookToolbar from './OrderbookToolbar.vue';
import OrderbookContent from './OrderbookContent.vue';
import { addRank, paddingOrderbookArray } from '@/utils/grouping';

@Component({
  name: 'BitFlyerOrderbook',
  components: {
    OrderbookToolbar,
    OrderbookContent,
  },
})
export default class BitFlyerOrderbook extends Vue {
  get loaded() {
    return this.paddingOrderbook.bids.length > 0 && BitFlyerModule.spread > 0 && BitFlyerModule.ltp > 0;
  }
  get orderbook() {
    return addRank(BitFlyerModule.orderbookArray);
  }
  get paddingOrderbook() {
    return paddingOrderbookArray(this.orderbook, BitFlyerModule.factor, BitFlyerModule.rowSize);
  }
  get ltp() {
    return BitFlyerModule.ltp;
  }
  get lastTickDirection() {
    return BitFlyerModule.lastTickDirection;
  }
  get spread() {
    return BitFlyerModule.spread;
  }

  public setFactor(factor: number) {
    BitFlyerModule.setFactor(factor);
  }
}
